import { XCircle } from "lucide-react";
import { RefundNotificationBanner } from "./refund-notification-banner";

interface GenerationFailedStateProps {
  errorMessage?: string;
  generationId: string;
  wasRefunded: boolean;
  refundAmount?: number;
  showRefundBanner: boolean;
  onTryAgain: () => void;
}

export function GenerationFailedState({
  errorMessage,
  generationId,
  wasRefunded,
  refundAmount,
  showRefundBanner,
  onTryAgain,
}: GenerationFailedStateProps) {
  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Refund notification banner */}
        {showRefundBanner && refundAmount && (
          <RefundNotificationBanner
            refundAmount={refundAmount}
            generationId={generationId}
          />
        )}

        {/* Error state */}
        <div className="text-center">
          <XCircle className="size-16 text-red-400 mx-auto mb-4" />
          <h1 className="text-xl sm:text-2xl font-bold text-white mb-2">
            Generation Failed
          </h1>
          <p className="text-[#888] mb-2">
            {errorMessage || "Something went wrong"}
          </p>
          {!showRefundBanner && wasRefunded && (
            <p className="text-sm text-green-400/80 mb-6">
              Your credits were refunded.
            </p>
          )}
          {!wasRefunded && (
            <p className="text-sm text-[#666] mb-6">
              Your credits have been refunded.
            </p>
          )}
          <button
            onClick={onTryAgain}
            className="px-6 py-3 rounded-xl bg-white/[0.1] text-white hover:bg-white/[0.15] transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}
